import { isBottomNavV1Enabled } from "@/config/bottomNav";
import { isAcademicStaffCourse } from "@/utils/funcionarios";
import { isFuncionariosCourse, isKioskCourse, } from "@/utils/parseCourseCode";
/**
 * Curso, CPA, alumno y personal académico (docente, rector, administración).
 * Portería, inspector, chofer y kiosco siguen en el shell anterior.
 */
export const isBottomNavEligibleMembership = (curso, _userEmail) => {
    if (!curso)
        return false;
    if (isKioskCourse(curso))
        return false;
    if (isFuncionariosCourse(curso))
        return isAcademicStaffCourse(curso);
    return true;
};
/** Shell con bottom nav: flag + membresía activa elegible. */
export const shouldUseBottomNavShell = (curso, userEmail) => isBottomNavV1Enabled() && isBottomNavEligibleMembership(curso, userEmail);
